module.exports = __webpack_public_path__ + "a768e7de/img/SOURCERY_poweredby_web.9819842b.png";